"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricDrawControl = void 0;
const react_1 = __importDefault(require("react"));
const mapbox_gl_draw_1 = __importDefault(require("@mapbox/mapbox-gl-draw"));
const gjcoords = __importStar(require("@mapbox/geojson-coords"));
const FabricDrawingModes_1 = require("../../utils/drawing-manager/FabricDrawingModes");
const MeasurementUom_1 = require("../../utils/drawing-manager/MeasurementUom");
const map_1 = require("../map");
const gds_ux_components_1 = require("@granular/gds-ux-components");
require("@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css");
const FabricDrawingManagerStyles_1 = require("./FabricDrawingManagerStyles");
const util_1 = require("../util");
const react_intl_1 = require("react-intl");
require("./FabricDrawControl.scss");
const turf_1 = require("@turf/turf");
const DrawScaleRotate_1 = require("../../utils/drawing-manager/modes/DrawScaleRotate");
class FabricDrawControl extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.initializeDraw = () => {
            const { map, styles, defaultMode } = this.props;
            const drawStyles = styles
                ? [...FabricDrawingManagerStyles_1.FabricDrawingManagerStyles, ...DrawScaleRotate_1.SRStyle, ...styles]
                : [...FabricDrawingManagerStyles_1.FabricDrawingManagerStyles, ...DrawScaleRotate_1.SRStyle];
            const CustomDrawingModes = (0, FabricDrawingModes_1.getCustomDrawingModes)({
                disableDragFeature: this.props.disableDragFeature,
            });
            this.draw = new mapbox_gl_draw_1.default({
                displayControlsDefault: false,
                clickBuffer: this.props.clickBuffer,
                touchBuffer: this.props.touchBuffer,
                controls: {
                    // We enable the trash control here even though we don't want to show it.
                    // This allows us to be able to delete individual points. We hide the button
                    // via css. 💅
                    trash: true,
                },
                modes: Object.assign({}, CustomDrawingModes),
                defaultMode: defaultMode || FabricDrawingModes_1.DrawingMode.FEATURE_EDIT,
                styles: drawStyles,
            });
            // Add it to our map
            map.addControl(this.draw, "top-left");
            this.toggleCustomEsriAttribution(true);
            map.doubleClickZoom.disable();
            map.dragRotate.disable();
            if (!map.getSource("measurements")) {
                this.createMeasurementsSource(map);
            }
            if (!map.getLayer("label-layer")) {
                this.createMeasurementsLayer(map);
                // map.moveLayer("label-layer");
            }
            this.bindToEvents();
        };
        this.createMeasurementsSource = (map) => {
            map.addSource("measurements", {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [],
                },
            });
        };
        this.createMeasurementsLayer = (map) => {
            map.addLayer({
                id: "label-layer",
                type: "symbol",
                source: "measurements",
                layout: {
                    "text-field": ["get", "title"],
                    "text-writing-mode": ["horizontal", "vertical"],
                    "text-font": ["Avenir LT Pro Bold", "Arial Unicode MS Regular"],
                    "text-radial-offset": 0.7,
                    "text-justify": "auto",
                    "text-variable-anchor": ["top-right"],
                    "text-size": 14,
                    "text-keep-upright": true,
                },
                paint: {
                    "text-color": "#000",
                    "text-halo-width": 1.5,
                    "text-halo-color": "#fff",
                    "text-opacity": 1,
                },
            });
        };
        this.toggleCustomEsriAttribution = (esriAttribution) => {
            const { map } = this.props;
            if (map["_controls"]) {
                map["_controls"].forEach((c) => {
                    if (c["options"] && !c["options"]["modes"]) {
                        if (esriAttribution) {
                            c["options"]["customAttribution"] = "Powered by Esri";
                        }
                        else {
                            c["options"]["customAttribution"] = undefined;
                        }
                    }
                });
            }
        };
        this.bindToEvents = () => {
            const { map } = this.props;
            // Hook draw events
            map.on("draw.create", this.onDrawCreate);
            map.on("draw.update", this.onDrawUpdate);
            map.on("draw.render", this.onDrawRender);
            map.on("draw.modechange", this.onModeChange);
            map.on("draw.selectionchange", this.onSelectionChange);
        };
        this.destroy = () => {
            const { map } = this.props;
            if (!this.draw || !map || !map.getStyle()) {
                return;
            }
            map.removeControl(this.draw);
            map.off("draw.create", this.onDrawCreate);
            map.off("draw.update", this.onDrawUpdate);
            map.off("draw.render", this.onDrawRender);
            map.off("draw.modechange", this.onModeChange);
            map.off("draw.selectionchange", this.onSelectionChange);
            map.doubleClickZoom.enable();
            map.dragRotate.enable();
            this.toggleCustomEsriAttribution(false);
            this.draw = null;
        };
        this.onModeChange = () => {
            switch (this.props.currentMode) {
                case FabricDrawingModes_1.DrawingMode.SCALE_ROTATE:
                    this.changeDrawMode(FabricDrawingModes_1.DrawingMode.SIMPLE_SELECT);
                    break;
            }
        };
        this.onSelectionChange = () => {
            // Forced rerender for disabling icons
            this.setState(Object.assign(Object.assign({}, this.state), { ts: Date.now() }));
        };
        this.onDrawUpdate = (drawFeatures) => __awaiter(this, void 0, void 0, function* () {
            const { onDrawCreate } = this.props;
            const mode = this.draw.getMode();
            if (mode === FabricDrawingModes_1.DrawingMode.DIRECT_SELECT ||
                mode === FabricDrawingModes_1.DrawingMode.SIMPLE_SELECT) {
                onDrawCreate(FabricDrawingModes_1.DrawingMode.FEATURE_EDIT, drawFeatures, this.draw);
            }
            else {
                onDrawCreate(mode, drawFeatures, this.draw);
            }
        });
        this.onDrawRender = () => __awaiter(this, void 0, void 0, function* () {
            const { map, showMeasurements } = this.props;
            const allowedMeasurementModes = [
                FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_ADD,
                FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_CUT,
                FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_MERGE,
                FabricDrawingModes_1.DrawingMode.DRAW_POLYGON_REMOVE,
                FabricDrawingModes_1.DrawingMode.DRAW_LINE_CUT,
                FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_ADD,
                FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_CUT,
                FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_MERGE,
                FabricDrawingModes_1.DrawingMode.DRAW_RECTANGLE_REMOVE,
                FabricDrawingModes_1.DrawingMode.FEATURE_EDIT,
                FabricDrawingModes_1.DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER,
                FabricDrawingModes_1.DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP,
                FabricDrawingModes_1.DrawingMode.SCALE_ROTATE,
            ];
            const all = this.draw.getAll();
            if (all &&
                all.features &&
                allowedMeasurementModes.includes(this.props.currentMode) &&
                showMeasurements) {
                const labelFeatures = [];
                all.features.forEach((feature) => {
                    const coords = gjcoords(feature);
                    try {
                        for (let index = 0; coords[0][0] !== null && index < coords.length; index++) {
                            const coord1 = coords[index];
                            let coord2 = coords[0];
                            if (index < coords.length) {
                                coord2 = coords[index + 1];
                            }
                            if (coord1 &&
                                coord2 &&
                                JSON.stringify(coord1) !== JSON.stringify(coord2)) {
                                const p1 = (0, turf_1.point)(coord1);
                                const p2 = (0, turf_1.point)(coord2);
                                const mp = (0, turf_1.midpoint)(coord1, coord2);
                                mp.properties = {};
                                let units = "feet";
                                let unit_abbreviation = "ft";
                                if (this.props.measurementUnits) {
                                    if (this.props.measurementUnits ===
                                        MeasurementUom_1.MeasurementUnitOfMeasure.METRIC) {
                                        units = "meters";
                                        unit_abbreviation = "m";
                                    }
                                }
                                mp.properties["title"] = `${Math.round((0, turf_1.distance)(p1, p2, { units: units }))} ${unit_abbreviation}`;
                                labelFeatures.push(mp);
                            }
                        }
                    }
                    catch (e) {
                        // swallow the exception
                        // line strings that haven't set an origin yet.
                        // console.debug(e);
                    }
                });
                if (!map.getSource("measurements")) {
                    this.createMeasurementsSource(map);
                }
                if (!map.getLayer("label-layer")) {
                    this.createMeasurementsLayer(map);
                }
                map.getSource("measurements").setData({
                    type: "FeatureCollection",
                    features: labelFeatures,
                });
                map.moveLayer("label-layer");
            }
        });
        this.onDrawCreate = (drawFeatures) => __awaiter(this, void 0, void 0, function* () {
            const { onDrawCreate, map } = this.props;
            const mode = this.draw.getMode();
            onDrawCreate(mode, drawFeatures, this.draw);
            if (this.props.showMeasurements) {
                map.moveLayer("label-layer");
            }
        });
        this.changeDrawMode = (mode, deleteInEditFeatures = true) => {
            const { onChangeDrawMode, map } = this.props;
            if (deleteInEditFeatures) {
                this.draw.deleteAll();
            }
            if (this.props.currentMode !== mode) {
                onChangeDrawMode(mode, this.draw);
                if (mode === FabricDrawingModes_1.DrawingMode.TRASH && map.getLayer("label-layer")) {
                    map.removeLayer("label-layer");
                    map.removeSource("measurements");
                }
            }
            else {
                onChangeDrawMode(FabricDrawingModes_1.DrawingMode.SIMPLE_SELECT, this.draw);
            }
        };
        this.getDrawingModeActions = () => {
            const controls = Object.assign(Object.assign({}, FabricDrawingModes_1.DefaultDrawingControls), this.props.controls);
            const { undo, redo, currentMode, layer } = this.props;
            const actions = {
                [FabricDrawingModes_1.DrawingModeCategory.ADD]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.CUT]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.REMOVE]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.MERGE]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.EDIT]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.UNDO]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.REDO]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.DELETE]: new Array(),
                [FabricDrawingModes_1.DrawingModeCategory.TOOLS]: new Array(),
            };
            Object.keys(controls).forEach((category) => {
                const modes = controls[category];
                let disabled = false;
                switch (category) {
                    case FabricDrawingModes_1.DrawingModeCategory.UNDO:
                        disabled = undo.length === 0;
                        break;
                    case FabricDrawingModes_1.DrawingModeCategory.REDO:
                        disabled = redo.length === 0;
                        break;
                    case FabricDrawingModes_1.DrawingModeCategory.CUT:
                    case FabricDrawingModes_1.DrawingModeCategory.EDIT:
                    case FabricDrawingModes_1.DrawingModeCategory.MERGE:
                    case FabricDrawingModes_1.DrawingModeCategory.REMOVE:
                    case FabricDrawingModes_1.DrawingModeCategory.DELETE:
                        disabled = !layer || layer.features.length === 0;
                        break;
                }
                if (modes) {
                    modes.forEach((mode) => {
                        var _a, _b;
                        const modeOption = FabricDrawingModes_1.drawingModeOptions[mode];
                        const modeAction = {
                            icon: modeOption.iconClass,
                            onClick: this.changeDrawMode.bind(this, mode),
                            disabled,
                            active: currentMode === mode,
                            tooltip: react_1.default.createElement(react_intl_1.FormattedMessage, { id: modeOption.title }),
                        };
                        switch (mode) {
                            case FabricDrawingModes_1.DrawingMode.SCALE_ROTATE:
                                if (
                                // !this.draw?.getSelectedIds()?.length ||
                                this.props.currentMode !== FabricDrawingModes_1.DrawingMode.FEATURE_EDIT &&
                                    this.props.currentMode !== FabricDrawingModes_1.DrawingMode.SCALE_ROTATE) {
                                    modeAction.disabled = true;
                                }
                                if (!((_b = (_a = this.draw) === null || _a === void 0 ? void 0 : _a.getSelectedIds()) === null || _b === void 0 ? void 0 : _b.length)) {
                                    modeAction.disabled = true;
                                }
                                modeAction.onClick = this.changeDrawMode.bind(this, mode, false);
                                break;
                        }
                        actions[category].push(modeAction);
                    });
                }
            });
            return actions;
        };
        this.render = () => {
            const actions = this.getDrawingModeActions();
            const { iconSize } = this.props;
            return (react_1.default.createElement(gds_ux_components_1.GKPosition, { position: gds_ux_components_1.Position.TL, className: "bg-map" },
                react_1.default.createElement("div", { className: "fabric-map-draw-controls" },
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.ADD].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent py-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.ADD], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Add" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.CUT].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent py-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.CUT], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Split" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.MERGE].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.MERGE], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Merge" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.REMOVE].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.REMOVE], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Remove" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.TOOLS].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.TOOLS], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Tools" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.EDIT].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.EDIT], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Edit" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.UNDO].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.UNDO], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Undo" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.REDO].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.REDO], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Redo" }), size: iconSize })),
                    react_1.default.createElement(util_1.Conditional, { match: !!actions[FabricDrawingModes_1.DrawingModeCategory.DELETE].length },
                        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark bg-transparent pb-2", actions: actions[FabricDrawingModes_1.DrawingModeCategory.DELETE], label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Delete" }), size: iconSize })))));
        };
    }
    componentDidMount() {
        this.initializeDraw();
    }
    componentDidUpdate(prevProps) {
        const { layer, currentMode } = this.props;
        if (currentMode === FabricDrawingModes_1.DrawingMode.FEATURE_EDIT &&
            (layer !== prevProps.layer ||
                FabricDrawingModes_1.DrawingMode.FEATURE_EDIT !== prevProps.currentMode)) {
            const currentFeatures = this.draw.getSelectedIds();
            if (layer) {
                this.draw.deleteAll();
                this.draw.add(layer);
                if (currentFeatures[0]) {
                    this.draw.changeMode(FabricDrawingModes_1.DrawingMode.DIRECT_SELECT, {
                        featureId: currentFeatures[0],
                    });
                }
            }
        }
        else if (currentMode === FabricDrawingModes_1.DrawingMode.SCALE_ROTATE &&
            (layer !== prevProps.layer ||
                FabricDrawingModes_1.DrawingMode.SCALE_ROTATE !== prevProps.currentMode)) {
            const toScaleFeatures = this.draw.getSelectedIds();
            if (layer) {
                this.draw.deleteAll();
                this.draw.add(layer);
                if (toScaleFeatures[0]) {
                    this.draw.changeMode(FabricDrawingModes_1.DrawingMode.DIRECT_SELECT, {
                        featureId: toScaleFeatures[0],
                    });
                    this.draw.changeMode(FabricDrawingModes_1.DrawingMode.SCALE_ROTATE);
                }
            }
        }
    }
    componentWillUnmount() {
        this.destroy();
    }
}
exports.FabricDrawControl = FabricDrawControl;
exports.default = (0, map_1.withMap)(FabricDrawControl);
